/**
 * TrialBadge — small countdown badge shown in the app header during trial.
 */

import { Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSubscription } from '@/lib/billing/useSubscription';
import { cn } from '@/lib/cn';

interface TrialBadgeProps {
  className?: string;
}

export function TrialBadge({ className }: TrialBadgeProps) {
  const { isTrialing, trialDaysLeft, trialKind } = useSubscription();

  if (!isTrialing || trialDaysLeft <= 0) return null;

  const urgent = trialDaysLeft <= 3;

  const tooltip =
    trialKind === 'grandfathered'
      ? 'Grandfathered trial — pick a plan in Settings'
      : trialKind === 'signup'
        ? 'Free trial — pick a plan in Settings'
        : 'Trial — pick a plan in Settings';

  return (
    <Link
      to="/settings"
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold transition-colors',
        urgent
          ? 'bg-warning-bg text-warning-dark border border-warning/40 hover:bg-warning-bg/80'
          : 'bg-info-bg text-info-dark border border-info/40 hover:bg-info-bg/80',
        className,
      )}
      title={tooltip}
    >
      <Sparkles className="w-3 h-3" />
      <span className="tabular-nums">
        {trialDaysLeft} {trialDaysLeft === 1 ? 'day' : 'days'} left
      </span>
    </Link>
  );
}
